export enum FlowSaveProgress {
  Permament = 'Permanent',
}
